import { Form, Formik, FormikHelpers } from 'formik'
import {FC, useEffect, useState} from 'react'
import * as Yup from 'yup'
import {Form as BsForm, Spinner} from 'react-bootstrap'
import {
  useLazyGetSoundNotificationSettingQuery,
  useUpdateSoundNotificationMutation,
} from '../../../../../services/cellcast'
import {toast} from 'react-toastify'
import { useDispatch } from 'react-redux'
import { fetchAsyncUserDetails } from '../Overview/OverviewSlice/UserDetailsSlice'

type NotificationSettings = {
  newNotification: boolean
  newInbox: boolean
}

const validationSchema = Yup.object({
  newNotification: Yup.boolean(),
  newInbox: Yup.boolean(),
})

const SoundNotification: FC = () => {
  const dispatch = useDispatch();
  const [initialValue, setInitialValue] = useState<NotificationSettings>({
    newNotification: true,
    newInbox: true,
  })

  // get RTK action
  const [update, {isLoading}] = useUpdateSoundNotificationMutation()
  const [fetchNotifications, {data: allNotifications}] = useLazyGetSoundNotificationSettingQuery()

  useEffect(() => {
      fetchNotifications(null)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  const onSubmit = (
    values: NotificationSettings,
    formikHelpers: FormikHelpers<NotificationSettings>
  ) => {
    update(values)
      .then((res) => {
        if ('data' in res) {
          if (res.data?.error && Object.keys(res.data?.error).length > 0) {
            toast.error(res?.data?.message)
          } else {
            toast.success(res?.data?.message)
            fetchNotifications(null)
            dispatch(fetchAsyncUserDetails())
          }
        } else if ('error' in res) {
          const resError = res.error as any
          if (resError.data?.message) {
            toast.error(resError.data?.message || '')
          } else {
            toast.error(res?.error.toString() || '')
          }
        }
      })
      .finally(() => {
        formikHelpers.setSubmitting(false)
      })
  }

  useEffect(() => {
    if (allNotifications?.data) {
      setInitialValue(allNotifications.data)
    }
  }, [allNotifications])

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_sound_notification'
      >
        <div className='card-title'>
          <h3 className='fs-2'>Sound Notification</h3>
        </div>
      </div>
      <div className='card-body' id='kt_sound_notification'>
        <Formik
          enableReinitialize
          initialValues={initialValue}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({isSubmitting, values, errors, touched, isValid, setFieldValue}) => (
            <Form>
              <div className='first-row'>
                <div className='row align-items-center'>
                  <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                    <label className='title-h5'>Enable New Notification</label>
                  </div>
                  <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                    <BsForm.Check
                      onChange={(e: any) => {
                        setFieldValue(
                          'newNotification',
                          !values.newNotification
                        )
                      }}
                      checked={values.newNotification}
                      type='switch'
                      id='enable-new-notification'
                    />
                  </div>
                </div>

                <div className='row align-items-center mt-4'>
                  <div className='col-xl-4 col-lg-5 col-md-5 col-sm-12 col-12'>
                    <label className='title-h5'>Enable New Inbox</label>
                  </div>
                  <div className='col-xl-8 col-lg-7 col-md-7 col-sm-12 col-12'>
                    <BsForm.Check
                      onChange={(e: any) => {
                        setFieldValue(
                          'newInbox',
                          !values.newInbox
                        )
                      }}
                      checked={values.newInbox}
                      type='switch'
                      id='enable-new-inbox'
                    />
                  </div>
                </div>

              </div>

              <div className='row border-top mt-2 p-4'>
                <div className='col-md-12 text-center text-xl-end text-lg-end text-md-end'>
                  <button
                    data-testid='btn-sound-notification'
                    className='btn btn-sm btn-primary'
                    type='submit'
                  >
                    {isLoading ? <Spinner /> : 'Save Changes'}
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default SoundNotification
